<template>
    <div class="customLink">
        <el-dialog title="自定义链接" :show-close='false' :visible.sync="centerDialogVisible" width="600px" center>
            <div class="linkBox">
                <span>链接地址</span>
                <el-input v-model="link" autocomplete="off" placeholder="http://"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'customLink',
    data() {
        return {
            centerDialogVisible: false,
            link: ''
        }
    },
    methods: {
        confirm() {
            let url = /[a-zA-z]+:\/\/[^\s]*/
            if (!url.test(this.link)) {
                this.$message.error('请输入链接')
            } else {
                this.centerDialogVisible = false
                this.$emit('setLink', this.link)
                this.link = ''
            }
        },
        openDialog() {
            this.centerDialogVisible = true
        },
        cancel() {
            this.centerDialogVisible = false
            this.$emit('cancel')
        }
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .customLink{
        .linkBox{
            display: flex;
            align-items: center;
            justify-content: space-around;
            span{
                width: 70px;
            }
            .el-input{
                width: 500px;
            }
        }
    }
</style>